import { createI18n } from 'vue-i18n'

import fr from './locales/fr.json'
import en from './locales/en.json'

function getLocale() {
  const lang = document.documentElement.lang || 'fr'

  if (lang.startsWith('en')) return 'en'
  if (lang.startsWith('fr')) return 'fr'

  return 'fr'
}

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: getLocale(),
  fallbackLocale: 'en',
  messages: {
    fr,
    en
  }
})

export default i18n